module.exports = __webpack_public_path__ + "img/About_Freelancers_DARK-03.d8f4abd.svg";